/// <amd-module name="TFS/Admin/Groups/Pivots/Settings/Components/SettingsDeleteCard" />
import * as React from "react";
import * as Resources from "TFS/Admin/Groups/Pivots/Settings/Resources";
import { ObservableValue } from "VSS/Core/Observable";
import { format } from "VSS/Core/Util/String";
import { WrappedComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { Card } from "VSSUI/Card";
import { Observer } from "VSSUI/Observer";
import { PermissionsGroup } from "TFS/Admin/Groups/Common/Contracts";
import { IDeleteDialogProps } from "TFS/Admin/Common/Controls/DeleteDialog/DeleteDialog.Props";

interface SettingsDeleteCardProps {
    groupName: string;
    itemToDelete: any;
    onDeleteItemConfirm: (selectedItem: PermissionsGroup) => void;
    disabled: boolean;
    entityType: string;
}

interface SettingsDeleteCardState {}

export class SettingsDeleteCard extends React.Component<SettingsDeleteCardProps, SettingsDeleteCardState> {
    private isDialogOpen = new ObservableValue<boolean>(false);

    public render(): JSX.Element {
        return (
            <>
                <div className="groups-settings-delete">
                    <Card titleProps={{ text: format(Resources.DeleteGroupSettingsCardTitle, this.props.entityType), ariaLevel: 2 }}>
                        <div className="flex-column flex-grow rhythm-vertical-16">
                            <div className="flex-row flex-grow">
                                {format(Resources.DeleteGroupSettingsCardText, this.props.entityType.toLocaleLowerCase())}
                            </div>
                            <div className="flex-row flex-grow">
                                <Button
                                    text={format(Resources.DeleteGroupButton, this.props.entityType)}
                                    onClick={() => {
                                        this.isDialogOpen.value = true;
                                    }}
                                    disabled={this.props.disabled}
                                />
                            </div>
                        </div>
                    </Card>
                </div>
                <Observer isDialogOpen={this.isDialogOpen}>
                    {(props: { isDialogOpen: boolean }) => {
                        return props.isDialogOpen ? (
                            <WrappedComponent<IDeleteDialogProps>
                                wrappedType="ms.vss-admin-web.delete-dialog"
                                dependencies={["ms.vss-admin-web.admin-common-controls-content"]}
                                wrappedProps={{
                                    onCancel: this._onDismiss,
                                    onDeleteItemConfirm: this._onDeleteItemConfirm,
                                    itemToDelete: this.props.itemToDelete,
                                    dialogTitle: format(Resources.DeleteGroupDialogTitle, this.props.entityType),
                                    confirmationMessage: Resources.DeleteGroupConfirmationMessage,
                                    groupOrUserName: this.props.entityType.toLocaleLowerCase(),
                                    itemName: this.props.groupName,
                                    warningMessage: format(Resources.DeleteGroupWarning, this.props.entityType.toLocaleLowerCase())
                                }}
                            />
                        ) : null;
                    }}
                </Observer>
            </>
        );
    }

    private _onDismiss = () => {
        this.isDialogOpen.value = false;
    };

    private _onDeleteItemConfirm = (selectedItem: PermissionsGroup) => {
        this.props.onDeleteItemConfirm(selectedItem);
        this._onDismiss();
    };
}
